import { Box, Button, TagColor as Color, Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { ShiftConfigWithBreaksForm } from 'modules/shift_management/components/Settings/ShiftTemplates/Content/EditTemplateWeek/WeekSettings/WeekConfiguration/forms'
import type PlannedBreakForm from 'modules/shift_management/lib/forms/PlannedBreakForm'

interface Props {
  form: PlannedBreakForm
  shiftConfig: ShiftConfigWithBreaksForm
  onDeleteBreak: (shiftConfig: ShiftConfigWithBreaksForm, form: PlannedBreakForm) => void
}
const BreakDetails = ({ form, onDeleteBreak, shiftConfig }: Props) => {
  const paidAttributes = form.get('break_configuration.paid').value
    ? {
        color: Color.lime,
        description: i18n.t('company_settings.time.breaks.paid'),
      }
    : {
        color: Color.malibu,
        description: i18n.t('company_settings.time.breaks.unpaid'),
      }

  const breakTypeAttr = () => {
    const breakType = form.get('break_type').value
    switch (breakType) {
      case 'flexible':
        return {
          color: Color.champagne,
          title: i18n.t('shift_management.breaks.add_break.flexible.title'),
        }
      case 'fixed':
        return {
          color: Color.purple,
          title: i18n.t('shift_management.breaks.add_break.fixed.title'),
        }
      case 'semi_flexible':
        return {
          color: Color.viridian,
          title: i18n.t('shift_management.breaks.add_break.semi_flexible.title'),
        }
      default:
        return {}
    }
  }
  return (
    <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
      <Box flexDirection="row" gap="s8" alignItems="center">
        <Text.Normal weight="medium" size="200">
          {form.get('break_configuration.name').value}
        </Text.Normal>
        <Tag type={paidAttributes.color}>{paidAttributes.description}</Tag>
        <Tag type={breakTypeAttr().color}>{breakTypeAttr().title}</Tag>
      </Box>

      <Button type="secondary" onClick={() => onDeleteBreak(shiftConfig, form)} iconName="delete" />
    </Box>
  )
}

export default observer(BreakDetails)
